import request from 'tools/request';

function getSharedConfig(params) {
  const data = {
    id: params.id,
    extract: params.extract,
  };
  return request.post('/api/share/query', data);
}

function checkShareUrl(params) {
  return request.get('/api/share/check', { params });
}

function getSignKey(params) {
  const data = {
    id: params.id,
    extract: params.extract,
    action: 'GetSignKey',
  };
  return request.post('/api/share/query', data);
}

export default { checkShareUrl, getSharedConfig, getSignKey };
